/**
 * SuperBrain DMCA / Copyright Policy
 * © 2026 A-1 Affiliate Marketing LLC - All Rights Reserved
 */

import React from 'react';
import MachineTranslationNotice from './MachineTranslationNotice';
import './LegalPage.css';

const DMCA = () => {
  return (
    <div className="legal-page" data-testid="dmca-page">
      <div className="legal-container">
        <button onClick={() => window.history.back()} className="back-btn" data-testid="dmca-back-btn">← Back</button>

        <MachineTranslationNotice />

        <h1>DMCA &amp; COPYRIGHT POLICY</h1>
        <p className="subtitle">SuperBrain Agentic Aggregate</p>
        <p className="effective-date">Effective Date: February 11, 2026</p>
        <p className="copyright">© 2026 A-1 Affiliate Marketing LLC. All Rights Reserved.</p>

        <section>
          <h2>1. Our Copyright</h2>
          <p>All software, design, branding, copy, audio, video, model orchestration logic, supervisor synthesis methodology, and trade dress comprising "SuperBrain Agentic Aggregate" are the exclusive intellectual property of A-1 Affiliate Marketing LLC. Unauthorized reproduction, redistribution, decompilation, or competitive use is strictly prohibited and will be prosecuted to the fullest extent of U.S. and international law.</p>
        </section>

        <section>
          <h2>2. Reporting Copyright Infringement</h2>
          <p>If you believe content on SuperBrain infringes <strong>your</strong> copyright, send a written DMCA notice containing:</p>
          <ul>
            <li>Your physical or electronic signature</li>
            <li>Identification of the copyrighted work claimed to have been infringed</li>
            <li>Identification of the material on SuperBrain that you claim is infringing (URL or specific location)</li>
            <li>Your name, address, phone number, and email address</li>
            <li>A statement that you have a good-faith belief that the use is not authorized by the owner, agent, or law</li>
            <li>A statement, under penalty of perjury, that the information in your notice is accurate and that you are the owner (or authorized to act on behalf of the owner) of the exclusive right allegedly infringed</li>
          </ul>
        </section>

        <section>
          <h2>3. Where to Send DMCA Notices</h2>
          <p>
            <strong>Designated Copyright Agent — A-1 Affiliate Marketing LLC</strong><br/>
            Email: <a href="mailto:a1affiliatemarketingllc@gmail.com">a1affiliatemarketingllc@gmail.com</a><br/>
            Subject line: <em>DMCA Takedown Notice</em>
          </p>
          <p>We aim to respond to valid DMCA notices within <strong>5 business days</strong>.</p>
        </section>

        <section>
          <h2>4. Counter-Notification</h2>
          <p>If material you posted was removed and you believe it was a mistake or misidentification, you may submit a counter-notification with the same information as above plus a statement (under penalty of perjury) that you have a good-faith belief the material was removed in error. Counter-notifications go to the same email above.</p>
        </section>

        <section>
          <h2>5. Repeat Infringer Policy</h2>
          <p>Accounts that are the subject of repeated valid DMCA notices will be terminated. We reserve the right to terminate any account at any time for actual or suspected copyright violations.</p>
        </section>

        <section>
          <h2>6. False Claims</h2>
          <p>Submitting a knowingly false DMCA claim is perjury under U.S. law (17 U.S.C. § 512(f)) and may result in liability for damages, including attorney's fees. Please be certain before filing.</p>
        </section>

        <section>
          <h2>7. AI-Generated Output</h2>
          <p>SuperBrain's AI-generated answers are synthesized in real time from licensed third-party AI models. We do not store or republish copyrighted source material. If you believe an AI response inadvertently reproduces protected content verbatim, please report it via the address above and we will investigate.</p>
        </section>

        <section>
          <h2>8. Contact</h2>
          <p>A-1 Affiliate Marketing LLC<br/>Email: <a href="mailto:a1affiliatemarketingllc@gmail.com">a1affiliatemarketingllc@gmail.com</a></p>
        </section>
      </div>
    </div>
  );
};

export default DMCA;
